import { useEffect } from 'react';

import type { ModelWarehouseFilter } from '@app/services/rtkQuery/Warehouses/types';

interface UseWarehousesRegistryEffectsProps {
  initialFilterPayload: ModelWarehouseFilter;
  searchWarehousesHandler: (data: ModelWarehouseFilter) => Promise<void>;
  getBranchesForSystemHandler: () => Promise<void>;
}

export const useWarehousesRegistryEffects = ({
  initialFilterPayload,
  searchWarehousesHandler,
  getBranchesForSystemHandler,
}: UseWarehousesRegistryEffectsProps) => {
  useEffect(() => {
    searchWarehousesHandler(initialFilterPayload);
  }, [initialFilterPayload, searchWarehousesHandler]);

  useEffect(() => {
    getBranchesForSystemHandler();
  }, [getBranchesForSystemHandler]);
};
